import { Button, Col, Container, Row } from "react-bootstrap";

function SectionFor(){
    return(
        <section id="section-for">
            <div id="overlay"></div>
            <Container>
                <Row id="section-for-text">
                    <Col lg={8}> 
                        <h3 >
                        Baked fresh daily by bakers with passion.
                        </h3>
                    </Col>
                    <Col> 
                        <Button>
                            Learn More
                        </Button>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}
export default SectionFor;